<script lang="ts">
  import { convertToDistributorLocalWithTime } from "@shared/svelte/Components/DateFormatter/LocaleString.svelte";
  import type { Event } from "@shared/types/Order";

  import { VT_802_SPIRITS_DISTRIBUTOR_ID } from "@shared/services/retailer_user_authentication/constants";

  export let events: Event[];
  //@ts-ignore
  let C = window.C;
  let images = {
    order_submitted: {
      image: C.IMAGE_PATHS["icons/order-timeline/submitted.svg"],
      label: "event-img-submitted",
    },
    order_accepted: {
      image: C.IMAGE_PATHS["icons/order-timeline/accepted.svg"],
      label: "event-img-accepted",
    },
    order_partially_accepted: {
      image: C.IMAGE_PATHS["icons/order-timeline/item-accepted.svg"],
      label: "event-img-partially-accepted",
    },
    order_rejected: {
      image: C.IMAGE_PATHS["icons/order-timeline/rejected.svg"],
      label: "event-img-rejected",
    },
    order_seen: { image: C.IMAGE_PATHS["icons/order-timeline/seen.svg"], label: "event-img-seen" },
    order_ready_for_pickup: {
      image: C.IMAGE_PATHS["icons/order-timeline/ready-for-pickup.svg"],
      label: "event-img-ready-for-pickup",
    },
    out_of_stock: {
      image: C.IMAGE_PATHS["icons/order-timeline/item-outofstock.svg"],
      label: "event-img-out-of-stock",
    },
    product_removed_by_rep: {
      image: C.IMAGE_PATHS["icons/order-timeline/item-outofstock.svg"],
      label: "event-img-out-of-stock",
    },
    product_backordered: {
      image: C.IMAGE_PATHS["icons/order-timeline/item-outofstock.svg"],
      label: "event-img-out-of-stock",
    },
    new_order_email: {
      image: C.IMAGE_PATHS["icons/order-timeline/order-sent.svg"],
      label: "event-img-sent",
    },
    new_concierge_order_email: {
      image: C.IMAGE_PATHS["icons/order-timeline/order-sent.svg"],
      label: "event-img-sent",
    },
    default: {
      image: C.IMAGE_PATHS["icons/order-timeline/notification.svg"],
      label: "event-img-sent",
    },
  };

  const isVermont = events.find(e => e.distributor_id === VT_802_SPIRITS_DISTRIBUTOR_ID);
  function getImage(action, to?: string) {
    if (isVermont) {
      if (action === "status_updated" && to === "Seen") {
        return images["order_ready_for_pickup"];
      }
      if (action === "status_updated" && to === "Confirmed") {
        return images["order_accepted"];
      }
      if (action === "status_updated" && to === "Rejected") {
        return images["order_rejected"];
      }
    }
    return images[action] || images["default"];
  }
</script>

{#each events as event}
  <div class="order-timeline__item" order-event-id={event.order_event_id}>
    <div class="order-timeline__item-icon">
      <img
        class={getImage(event.action, event.event_data.to).label}
        alt={getImage(event.action, event.event_data.to).label}
        src={getImage(event.action, event.event_data.to).image}
      />
    </div>
    <div class="order-timeline__item-content secondary-small--bold">
      {convertToDistributorLocalWithTime(event.created_at)}
    </div>
    <div class="order-timeline__item-content default-body--regular">{event.event_data.msg}</div>
  </div>
{/each}
